module.exports = __webpack_public_path__ + "static/sharevel-logo-bc100d4b26bf5afcb45594de99d692d2.png";